import { gql } from '@provision/graphql-client';
import { getStoredAttributeHooks } from './stored-attributes';

const CLIENT_CUSTOM_ATTRIBUTES_FRAGMENT = gql`
  fragment ClientCustomAttributesFields on Client {
    id
    clientId
    customAttributes
  }
`;

const GET_CLIENT_CUSTOM_ATTRIBUTES = gql`
  query GetClientCustomAttributes($params: QueryParamsWithSearch) @entity(name: "Client") {
    getClient(queryParams: $params) {
      records {
        id
        clientId
        customAttributes
      }
    }
  }
`;

const UPDATE_CLIENT_CUSTOM_ATTRIBUTES_MUTATION = gql`
  mutation UpdateClientCustomAttributes(
    $conditions: [ConditionInput]
    $data: ClientDataInput
  ) {
    updateClient(conditions: $conditions, data: $data) {
      ...ClientCustomAttributesFields
    }
  }
  ${CLIENT_CUSTOM_ATTRIBUTES_FRAGMENT}
`;

export const clientCustomAttributesConfig = getStoredAttributeHooks({
  typename: 'Client',
  idAttribute: 'clientId',
  fragment: CLIENT_CUSTOM_ATTRIBUTES_FRAGMENT,
  fragmentName: 'ClientCustomAttributesFields',
  query: GET_CLIENT_CUSTOM_ATTRIBUTES,
  queryRootField: 'getClient',
  mutation: UPDATE_CLIENT_CUSTOM_ATTRIBUTES_MUTATION,
});
